import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  title?: string;
  description?: string;
  noPadding?: boolean;
  disabled?: boolean;
  variant?: 'danger';
}


import { computed, useSlots } from 'vue';

declare module 'vue/types/vue' {
  export interface Vue {
    ModalFormSection: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'ModalFormSection' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: null,
    description: null,
    noPadding: { type: Boolean },
    disabled: { type: Boolean },
    variant: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  description?: string;
  noPadding?: boolean;
  disabled?: boolean;
  variant?: 'danger';
};

/**
 * `ModalFormSection` component properties.
 */


const slots = useSlots();

const hasHeaderContent = computed(() => {
  return 'header' in slots;
});

const showHeader = computed(() => {
  return !!props.title || !!props.description || hasHeaderContent.value;
});

return { __sfc: true,props, slots, hasHeaderContent, showHeader }
}

})